import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _PettyCashBudgetIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0114 14.4063C17.68 14.4063 17.4138 14.1572 17.3488 13.8322C16.7335 10.5803 13.76 8.21875 10.2813 8.21875C6.80252 8.21875 3.82908 10.5803 3.21377 13.8322C3.11345 14.3614 3.06281 14.8989 3.06252 15.4375C3.05998 16.6095 3.29991 17.7693 3.7672 18.8441C3.9008 19.1579 4.12337 19.4257 4.40742 19.6144C4.69148 19.8032 5.02459 19.9046 5.36564 19.9063C5.80229 19.9063 6.15627 20.2602 6.15627 20.6969V21.1781C6.15627 21.6148 5.80229 21.9688 5.36564 21.9688C4.62284 21.9669 3.89679 21.7479 3.27687 21.3387C2.65695 20.9295 2.17021 20.3479 1.87658 19.6656C1.296 18.3318 0.997561 16.8922 1.00002 15.4375C1.00002 14.772 1.06217 14.108 1.18564 13.4541C1.47037 12.0086 2.10799 10.656 3.04177 9.5165C3.97554 8.37701 5.17652 7.48602 6.53783 6.92281C6.09102 6.48998 5.73572 5.97179 5.49302 5.39901C5.25033 4.82623 5.12518 4.21052 5.12502 3.58844C5.12502 2.15888 6.2839 1 7.71345 1H12.8491C14.2786 1 15.4375 2.15888 15.4375 3.58844C15.4369 4.20994 15.3115 4.82499 15.0688 5.39716C14.8262 5.96932 14.4711 6.48695 14.0247 6.91938C15.386 7.48259 16.587 8.37358 17.5208 9.51306C18.4545 10.6525 19.0922 12.0052 19.3769 13.4506C19.4709 13.9596 19.0632 14.4063 18.5457 14.4063H18.0114ZM8.4043 5.77459C8.81015 6.02552 9.27818 6.15773 9.75533 6.15625H10.8072C11.4882 6.15625 12.1414 5.88572 12.6229 5.40416C13.1045 4.9226 13.375 4.26947 13.375 3.58844C13.375 3.29797 13.1395 3.0625 12.8491 3.0625H7.71345C7.42299 3.0625 7.18752 3.29797 7.18752 3.58844C7.1882 3.98698 7.28115 4.37995 7.45908 4.73656C7.671 5.16407 7.99845 5.52367 8.4043 5.77459Z"
        fill={iconColor}
      />
      <Path
        d="M9.59374 20.9375H13.375C13.9445 20.9375 14.4062 21.3992 14.4062 21.9688C14.4062 22.5383 13.9445 23 13.375 23H9.59373C9.02419 23 8.56249 22.5383 8.56249 21.9688C8.56249 21.3992 9.02419 20.9375 9.59374 20.9375Z"
        fill={iconColor}
      />
      <Path
        d="M13.375 16.8125H9.59374C9.02419 16.8125 8.56249 17.2742 8.56249 17.8438C8.56249 18.4133 9.02419 18.875 9.59373 18.875H13.375C13.9445 18.875 14.4062 18.4133 14.4062 17.8438C14.4062 17.2742 13.9445 16.8125 13.375 16.8125Z"
        fill={iconColor}
      />
      <Path
        d="M9.59374 12.6875H13.375C13.9445 12.6875 14.4062 13.1492 14.4062 13.7188C14.4062 14.2883 13.9445 14.75 13.375 14.75H9.59373C9.02419 14.75 8.56249 14.2883 8.56249 13.7188C8.56249 13.1492 9.02419 12.6875 9.59374 12.6875Z"
        fill={iconColor}
      />
      <Path
        d="M21.2812 20.9375H17.5C16.9304 20.9375 16.4687 21.3992 16.4687 21.9688C16.4687 22.5383 16.9304 23 17.5 23H21.2812C21.8508 23 22.3125 22.5383 22.3125 21.9688C22.3125 21.3992 21.8508 20.9375 21.2812 20.9375Z"
        fill={iconColor}
      />
      <Path
        d="M17.5 16.8125H21.2812C21.8508 16.8125 22.3125 17.2742 22.3125 17.8438C22.3125 18.4133 21.8508 18.875 21.2812 18.875H17.5C16.9304 18.875 16.4687 18.4133 16.4687 17.8438C16.4687 17.2742 16.9304 16.8125 17.5 16.8125Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const PettyCashBudgetIcon = assignWithoutSideEffects(_PettyCashBudgetIcon, {
  componentId: 'PettyCashBudgetIcon',
});

export default PettyCashBudgetIcon;
